import classNames from "classnames";
import React, { ReactNode, useState } from "react";
import { Collapse } from "react-bootstrap";
import { TreeView } from "./treeview";
import SvgChevronRight from "../icons/ChevronRight";

interface TreeViewItemProps {
    id?: string;
    variant?: "" | "text" | "menu";
    className?: string;
    title: ReactNode;
    selected?: boolean;
    compact?: boolean;
    expanded?: boolean;
    disabled?: boolean;
    focus?: boolean;
    href?: string;
    lazyload?: boolean;
    children?: ReactNode | (({ isExpanded, render }) => ReactNode);
    onToggleSelection?: (any) => any;
    onClick?: (e: any) => any;
    onTitleClick?: (e: any) => any;
    [x: string]: any;
}

export const TreeViewItem = ({
    id,
    variant,
    className,
    title,
    selected,
    compact,
    expanded,
    disabled,
    focus,
    href,
    lazyload,
    onToggleSelection,
    onClick,
    onTitleClick,
    children,
    ...props
}: TreeViewItemProps) => {
    if (!variant) variant = "menu";
    if (!href) href = "#";
    const [treeviewState, setTreeviewState] = useState({ isExpanded: expanded, render: expanded || !lazyload });

    const clickHandler = (e) => {
        e.preventDefault();
        if (onClick) {
            if (onClick(e) === false) return false;
        }
        if (variant === "text") return null;
        if (disabled) return false;
        if (!!children) {
            const isExpanded = !treeviewState.isExpanded;
            setTreeviewState({ isExpanded, render: true });
        }
        if (onToggleSelection) onToggleSelection(id);
        return false;
    };

    const onClickSpan = (e) => {
        if (disabled) return;
        if (variant === "text") {
            if (!!children) {
                const isExpanded = !treeviewState.isExpanded;
                setTreeviewState({ isExpanded, render: true });
            }
            if (onToggleSelection) onToggleSelection(id);
        }
    };

    let _children: any = children;
    if (!treeviewState.render) {
        if (!!_children) _children = <div></div>;
    } else if (typeof children === "function") _children = children({ isExpanded: treeviewState.isExpanded, render: treeviewState.render });

    if (_children && _children.length > 0) {
        if (_children[0]?.type !== TreeView) _children = <ul className="bd-treeview">{_children}</ul>;
    }

    if (!focus) props = { tabIndex: -1, ...props };

    return (
        <li>
            <a
                onClick={clickHandler}
                className={classNames("bd-treeview-item", className, {
                    disabled,
                    "bd-treeview-compact": compact,
                    "bd-treeview-menu": variant === "menu",
                    "bd-treeview-selected": selected,
                })}
                href={href}
                {...props}
            >
                <span className={classNames({ "cur-pointer": !!_children })} onClick={onClickSpan}>
                    {!!_children && (
                        <SvgChevronRight
                            className={classNames("transition-transform", {
                                "rotate-90": treeviewState.isExpanded,
                                "rtl-rotate-180": !treeviewState.isExpanded,
                            })}
                        />
                    )}
                </span>

                <div className="bd-treeview-label" onClick={onTitleClick}>
                    {title}
                </div>
            </a>

            {_children && (
                <Collapse in={treeviewState.isExpanded}>
                    <div>{_children}</div>
                </Collapse>
            )}
        </li>
    );
};
